import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby'
import Icon from 'images/icons/arrow.inline.svg';
import { buttonWrap, svg} from './buttonSelector.module.scss'

function ButtonSelector({
    link,
    title
}){
    return (
        <Link to={link} className={buttonWrap} title={`View ${title} docs`}>
            {title}
            <Icon
                className={svg}
                style={{ width: '20px', height: '20px', transform: 'rotate(-90deg) translateY(5px) scale(0.9)' }}
            />
        </Link>
    )
}

ButtonSelector.propTypes = {
    link: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired
}

export default ButtonSelector